<script setup>
import { computed, defineAsyncComponent, ref } from 'vue';
import FormGroup from '@maison/components/form/FormGroup.vue';
import SelectField from '@maison/components/form/fields/SelectField.vue';
import TextField from '@maison/components/form/fields/TextField.vue';
import PhoneField from '@maison/components/form/fields/PhoneField.vue';
import CheckboxField from '@maison/components/form/fields/CheckboxField.vue';

const PhoenixForm = defineAsyncComponent(() => import('@maison/components/form/PhoenixForm.vue'));

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:modelValue']);

const formRef = ref(null);

const fields = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});

const isPartner = computed(() => fields.value.partner.value);

const submit = async () => await formRef.value.submit();

defineExpose({ submit });
</script>

<template>
  <div class="text--muted">{{ $t('EngravingTool.checkout.contactInformationSubtitle') }}</div>

  <phoenix-form ref="formRef" v-model="fields" :captcha-enabled="false" :is-contained="false" naked class="mt-base">
    <div class="flex-grid flex-grid--y--base flex-grid--x--base">
      <form-group :attrs="fields.partner" :show-label="false" class="w-full">
        <checkbox-field v-model="fields.partner.value" />
      </form-group>

      <template v-if="isPartner">
        <form-group :attrs="fields.partnerName" class="w-1/2">
          <text-field v-model="fields.partnerName.value" />
        </form-group>

        <form-group :attrs="fields.partnerEmail" class="w-1/2">
          <text-field v-model="fields.partnerEmail.value" />
        </form-group>

        <form-group :attrs="fields.partnerCountry" class="w-1/2">
          <select-field v-model="fields.partnerCountry.value" />
        </form-group>

        <form-group :attrs="fields.partnerCity" class="w-1/2">
          <text-field v-model="fields.partnerCity.value" />
        </form-group>

        <h5 class="ecom-section__subtitle mt-sm">{{ $t('EngravingTool.checkout.clientInformationTitle') }}</h5>
      </template>

      <form-group :attrs="fields.title" class="w-full">
        <select-field v-model="fields.title.value" />
      </form-group>

      <form-group :attrs="fields.firstName" class="w-1/2">
        <text-field v-model="fields.firstName.value" />
      </form-group>

      <form-group :attrs="fields.lastName" class="w-1/2">
        <text-field v-model="fields.lastName.value" />
      </form-group>

      <form-group :attrs="fields.country" class="w-full">
        <select-field v-model="fields.country.value" />
      </form-group>

      <form-group :attrs="fields.city" class="w-1/2">
        <text-field v-model="fields.city.value" />
      </form-group>

      <form-group :attrs="fields.zip" class="w-1/2">
        <text-field v-model="fields.zip.value" />
      </form-group>

      <form-group :attrs="fields.email" class="w-1/2">
        <text-field v-model="fields.email.value" />
      </form-group>

      <form-group :attrs="fields.phone" class="w-1/2" data-cy="phone-field">
        <phone-field v-model="fields.phone.value" />
      </form-group>
    </div>
  </phoenix-form>
</template>
